export const chatKeys = {
  all: ['chat'] as const,
  stream: ['chat', 'stream'] as const,
}
